// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hQ0UT2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-2);
  width: 100%;
  padding: var(--spacing-3);
  background: var(--background-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.IK5cE4 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: 1.8;
  color: var(--text-neutral-dark);
  word-break: break-word;
}

.qyB5P9 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
  color: var(--text-neutral-dark);
  word-break: break-word;
}

.HdjusD {
  font-weight: var(--font-weight-medium);
}

.EerGi1 {
  align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/BilletDiscontinuedBanner/BilletDiscontinuedBanner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  width: 100%;\n  padding: var(--spacing-3);\n  background: var(--background-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  overflow: hidden;\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.8;\n  color: var(--text-neutral-dark);\n  word-break: break-word;\n}\n\n.description {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.4;\n  color: var(--text-neutral-dark);\n  word-break: break-word;\n}\n\n.highlight {\n  font-weight: var(--font-weight-medium);\n}\n\n.button {\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hQ0UT2`,
	"title": `IK5cE4`,
	"description": `qyB5P9`,
	"highlight": `HdjusD`,
	"button": `EerGi1`
};
module.exports = ___CSS_LOADER_EXPORT___;
